'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import React, { useEffect } from 'react'
import { getBootstrappedFlags } from './get-bootstrapped-flags'
import { initPostHog } from './init-posthog'

export const PostHogProvider = ({
  children
}: {
  children: React.ReactNode
}): React.ReactElement => {
  useEffect(() => {
    const flags = getBootstrappedFlags()
    initPostHog(flags)
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
